import ReactTable from "react-table";
import React from "react";

export default props => (
  <ReactTable
    className={"stats-table"}
    showPagination={false}
    showPageSizeOptions={false}
    sortable={true}
    defaultPageSize={9999999}
    minRows={0}
    noDataText={"No Data Available Yet"}
    {...props}
  />
);
